import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { t } from '../../i18n/t';
import './SwapUfModal.css';

interface SwapUfModalProps {
  title: string;
  onClose: () => void;
  wide?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

// Centered, animated modal in the LopTabsCapModal style. z-index sits BELOW
// LopSearchModal (1000) so the asset picker opened from inside this dialog is visible.
export function SwapUfModal({ title, onClose, wide = false, children, footer }: SwapUfModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !document.querySelector('.lop-search-modal')) onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div
      className="swap-uf-modal__backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`swap-uf-modal${wide ? ' swap-uf-modal--wide' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="swap-uf-modal__header">
          <h2 className="swap-uf-modal__title">{title}</h2>
          <button
            type="button"
            className="swap-uf-modal__x"
            aria-label={t('swapUf.modal.close')}
            onClick={onClose}
          >
            <X size={16} />
          </button>
        </header>
        <div className="swap-uf-modal__body">{children}</div>
        {footer && <footer className="swap-uf-modal__footer">{footer}</footer>}
      </div>
    </div>,
    document.body,
  );
}
